import React, {useState, useEffect} from 'react'
import {
  Route,
  Switch,
  BrowserRouter as Router
} from 'react-router-dom'
import axios from 'axios'
import moment from 'moment'
import Clock from 'react-live-clock'
import {Helmet} from "react-helmet"
import { Icon, Label, Popup } from 'semantic-ui-react'
import {WindowURLClient,WindowLocation,WindowLocationClient,WindowReload} from '../config/settings'
import Alertmessage from '../config/alert'

import TradingBuyComponent from './pages/tradingbuy/list'
import TradingSellComponent from './pages/tradingsell/list'
import FundingRecordComponent from './pages/fundingrecord/list'
import FundingTransferComponent from './pages/fundingtransfer/list'
import CLientAccountComponent from './pages/account/account'

import TradeOrderComponent from './pages/tradeorder/list'

import ChangePasswordComponent from './pages/changepassword/list'
import HelpDeskComponent from './pages/helpdesk/list'

import Logo from '../../assets/images/logo.png'

export default function AppClient(props) {

  const [alert,setalert] = useState(true);
  const [Alertcontent,setAlertcontent] = useState({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait..."}});
  function Alertclose(){setalert(false);}
  function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
  function Alertdelete(data){
    if(data.delete==true){
      //console.log(data.id);
    }
  }

  function AddCustomClassBody(){
    document.body.classList.add("admin");
  }
  const [active, setactive] = useState('');
  function ActiveClass(){
    let path = window.location.pathname;
    var url=path.split('/');
    setactive(url[3]);
  }

  const [customer, setcustomer] = useState('Guest');
  function LoginAccount(){
    let formData = new FormData();
    formData.append('type','clientuser');
    axios.post('/client/login/http.php',formData)
    .then(function (response) {
        let obj = response.data;
        if(obj==0){WindowLocation('/member-login');return false;}
        setcustomer(obj);
        setTimeout(function() {setalert(false);},2000);
    })
    .catch(function (error){
      setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
      setTimeout(function() {setalert(false);},2000);
    });
  }

  function LogoutAccount(){

    setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

    let formData = new FormData();
    formData.append('type','logout');
    axios.post('/client/login/http.php',formData)
    .then(function (response) {
        let obj = response.data;
        if(obj=='success'){
          setTimeout(function() {WindowLocation('/member-login');},2000);
          return false;
        }
        setTimeout(function() {WindowReload();},2000);
    })
    .catch(function (error){
      setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
      setTimeout(function() {setalert(false);},2000);
    });
  }

  useEffect(()=>{
    AddCustomClassBody();
    ActiveClass();
    LoginAccount();
  },[]);

	return (
    <React.Fragment>

      <Helmet>
          <title>Gold Grup Limited- Client Dashboard</title>
      </Helmet>

      {alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}

      <div className="app-header-wrapper">
         <div className="app-container">
           <div className="app-logo-wrapper">
              <div><img src="https://primecapitalmarkets.net/assets/images/logo.png"/></div>
              <div>
                 <p><Clock date={new Date()} format={'dddd, MMMM DD, YYYY'} /> | <Clock format="h:mm:ss A" interval={1000} ticking={true} /></p>
                 <p><span><i className="uil-user"></i>Hi, {customer}</span> | <span onClick={()=>LogoutAccount()}>Logout</span></p>
              </div>
           </div>
         </div>
      </div>

			 <div className="app-menu-wrapper">
			 		<div className="app-container">
						<ul className="navmenu">
							 <li className={active=='account'?'active':''}><a href={WindowURLClient('/account')}><i className="uil-users-alt"></i>Account</a></li>
							 <li className={active=='tradingbuy'?'active':''}><a href={WindowURLClient('/tradingbuy')}><i className="uil-cart"></i>Trading Record-Buy</a></li>
							 <li className={active=='tradingsell'?'active':''}><a href={WindowURLClient('/tradingsell')}><i className="uil-cart"></i>Trading Record-Sell</a></li>
               <li className={active=='trade-order'?'active':''}><a href={WindowURLClient('/trade-order')}><i className="uil-shopping-cart-alt"></i>Trade Order</a></li>
							 <li className={active=='funding-record'?'active':''}><a href={WindowURLClient('/funding-record')}><i className="uil-bag-alt"></i>Funding Record</a></li>
               <li className={active=='funding-transfer'?'active':''}><a href={WindowURLClient('/funding-transfer')}><i className="uil-package"></i>Funding Transfer</a></li>
							 <li className={active=='change-password'?'active':''}><a href={WindowURLClient('/change-password')}><i className="uil-lock-alt"></i>Change Password</a></li>
							 <li className={active=='help-desk'?'active':''}><a href={WindowURLClient('/help-desk')}><i className="uil-user-check"></i>Help Desk</a></li>
						</ul>
					</div>
			 </div>

			 <div className="app-content">
          <div className="app-container">
    				 <Router>
    					 <Switch>
    						 <Route exact path={WindowURLClient('/')}  component={CLientAccountComponent}/>
                 <Route exact path={WindowURLClient('/account')}  component={CLientAccountComponent}/>
                 <Route exact path={WindowURLClient('/tradingbuy')}  component={TradingBuyComponent}/>
                 <Route exact path={WindowURLClient('/tradingsell')}  component={TradingSellComponent}/>
                 <Route exact path={WindowURLClient('/trade-order')}  component={TradeOrderComponent}/>
                 <Route exact path={WindowURLClient('/funding-record')}  component={FundingRecordComponent}/>
                 <Route exact path={WindowURLClient('/funding-transfer')}  component={FundingTransferComponent}/>
                 <Route exact path={WindowURLClient('/change-password')}  component={ChangePasswordComponent}/>
                 <Route exact path={WindowURLClient('/help-desk')}  component={HelpDeskComponent}/>
    					 </Switch>
    				 </Router>
             <div className="dashboard-footer">
                <p>Copyright © <Clock date={new Date()} format={'YYYY'} />  Gold Grup Limited</p>
             </div>
          </div>
			 </div>




    </React.Fragment>
	)
}
